import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

import type { TyreTeamCredentialID } from "models";

export const useValidateTyreTeamCredentialMutation = () =>
  useTypedMutation<TyreTeamCredentialID, void>({
    mutationFn: async credential_id => {
      await ApiInstance.post("/credentials/validate", { credential_id }, ENV.tyreTeamBaseURL);
    },
    onSuccess: () => null
  });
